import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const Root = styled.div`
  height: var(--half-unit);
  border-radius: var(--unit);
  background-color: var(--c-nd-200);
`;
const DurationProgress = styled.div`
  height: 100%;
  border-radius: var(--unit);
  background-color: var(--c-nd-700);
`;

export enum StoryStatus {
  SEEN,
  NOT_SEEN,
}

const INTERVAL = 10;

type Props = {
  playing: boolean;
  duration: number;
  onFinish: () => void;
  storyStatus?: StoryStatus;
  pause?: boolean;
};
export const DurationIndicator = ({
  playing,
  duration,
  onFinish,
  storyStatus,
  pause,
}: Props) => {
  const [timeElapsed, setTimeElapsed] = useState(0);
  const [storyFinished, setStoryFinished] = useState(false);
  const interval = useRef<ReturnType<typeof setTimeout>>(undefined);

  const stopPlaying = () => {
    if (interval.current) {
      clearInterval(interval.current);
    }
  };

  useEffect(() => {
    if (!interval.current && playing) {
      interval.current = setInterval(() => {
        if (!pause) setTimeElapsed(i => i + INTERVAL / 1000);
      }, INTERVAL);
    }
    if (!playing) {
      stopPlaying();
    }
    return () => stopPlaying();
  }, [pause, playing]);

  useEffect(() => {
    if (playing && timeElapsed >= duration && !storyFinished) {
      setStoryFinished(true);
      stopPlaying();
      onFinish();
    }
  }, [duration, onFinish, pause, playing, storyFinished, timeElapsed]);

  useEffect(() => {
    setTimeElapsed(0);
    setStoryFinished(false);
  }, [playing]);

  let width = Math.min(100, (timeElapsed * 100) / duration);
  if (storyStatus === StoryStatus.SEEN) {
    width = 100;
  } else if (storyStatus === StoryStatus.NOT_SEEN) {
    width = 0;
  }

  return (
    <Root>
      <DurationProgress style={{ width: `${width}%` }} />
    </Root>
  );
};
